// Chakra imports
import { Avatar, Box, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';

export default function Banner(props: {
	banner: string;
	name: string;
	job: string;
	[x: string]: any;
}) {
	const { banner, name, job, ...rest } = props;
	// Chakra Color Mode
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = 'gray.400';
	const borderColor = useColorModeValue('white !important', '#111C44 !important');
	return (
		<Card mb={{ base: '0px', lg: '20px' }} alignItems='center' {...rest}>
			<Box bg={`url(${banner})`} bgSize='cover' borderRadius='16px' h='131px' w='100%' />
			<Avatar bg="#11047A" color="white" mx='auto' name={name} h='87px' w='87px' mt='-43px' border='4px solid' borderColor={borderColor} />
			<Text color={textColorPrimary} fontWeight='bold' fontSize='xl' mt='10px'>
				{name.toUpperCase()}
			</Text>
			<Text color={textColorSecondary} fontSize='sm'>
				{job}
			</Text>
		</Card>
	);
}
